import * as _ from 'lodash'
import apiUrl from '@/common/apiUrl'
import webApiUtil from '@/common/webApiUtil'

export default {
  namespaced: true,
  actions: {
    getChartData: async ({rootState}, _params = {}) => {
      try {
        rootState.isLoading = true
        if (_params && _params.graph_api) {
          const params = _.merge({}, _params)
          delete params.graph_api

          const url = apiUrl[`${_params.graph_api}Graph`]
          const res = await webApiUtil.post(url, params)

          if (res && res.data && res.data.status === 0 && res.data.message !== 'No Data') {
            if (res.data['log_response']) {
              return res.data['log_response']
            } else {
              return null
            }
          } else {
            return null
          }
        } else {
          return null
        }
      } catch (e) {
        return null
      } finally {
        rootState.isLoading = false
      }
    }
  }
}
